const trans = {
    'en-us': {
        translation: {
            lang: 'en-us',
            cookie: {
                consent: {
                    message: 'We use cookies to improve our services and to guarantee users the employment of its site features. By continuing to browse the site you\'re agreeing to our use of cookies.',
                    buttonTxt: 'Okay',
                },
            },
            header: {
                barcodes: 'QR Code',
                phoneSkin: 'Phone Skin',
                contact: 'Contact',
            },
            layout: {
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
                repo: 'Repository',
                fullAddress: 'Kuloglu M. Aga Hamami S. No:13/2 Beyoglu, Istanbul, Republic of TURKEY',
                menu: 'Menu',
            },
            barcodes: {
                sponsorMessage: 'QR project was sponsored by',
                bgColor: 'Background Color',
                foreColor: 'Foreground Color',
                textualData: 'Textual Data [URL]',
                imageWidth: 'Image Size [Height and Width px]',
                logoWidth: 'Logo Size [Height and Width px]',
                opacity: 'Logo Opacity [{{val}}]',
                logoType: 'Logo Type',
                uploadLogo: 'Upload Logo',
                qrShape: 'QR Shape',
                dot: 'Dot',
                square: 'Square',
                preview: 'Preview',
                exportJpg: 'Export JPG',
                exportPng: 'Export PNG',
                customLogo: 'Custom Logo',
                error: {
                    invalidImageHead: 'Invalid Image Size',
                    invalidImageMinMsg: 'Please enter a positive value for image size',
                    invalidImageMaxMsg: 'Image size cannot be larger than {{val}} px',
                    invalidLogoHead: 'Invalid Logo Size',
                    invalidLogoMinMsg: 'Please enter a positive value for logo size',
                    invalidLogoMaxMsg: 'Logo size cannot be larger than {{val}} px',
                },
                addBorder: 'Add Frame',
                wBorder: 'With Frame',
                woBorder: 'Without Frame',
                borderRad: 'Corner Radius [{{val}}]px',
                lineWidth: 'Line Width [{{val}}]px',
                borderCol: 'Frame Color',
            },
            indexPage: {
                desc: 'A collective list of publicly available tools prepared by doDoubt.',
                barcodeGen: 'QR Code Generator',
                phoneSkin: 'Phone Skins',
            },
            phonePrePage: {
                option: {
                    imacPro: 'iMac Pro',
                    iphonex: 'iPhone X',
                    iphone8: 'iPhone 8 [White]',
                    iphone8Gold: 'iPhone 8 [Gold]',
                    ipadpro: 'iPad Pro',
                    pixel: 'Pixel [White]',
                    pixelBlack: 'Pixel [Black]',
                    pixelBlue: 'Pixel [Blue]',
                    pixel2xl: 'Pixel 2 XL',
                    galaxys8: 'Galaxy S8 [Black]',
                    galaxys8Blue: 'Galaxy S8 [Blue]',
                    surfaceStudio: 'Surface Studio',
                    appleWatch: 'Apple Watch',
                },
                visual: 'Visual',
                uploadVisual: 'Upload Visual',
                preview: 'Preview',
                removePreview: 'Remove Preview',
                deviceScale: 'Device Scale',
                addPhoneView: 'Add Phone View',
                exportFilesJpeg: 'Export Files [jpeg]',
                exportFilesPng: 'Export Files [png]',
                scaleSmall: 'Small',
                scaleMedium: 'Medium',
                scaleLarge: 'Large',
                pleaseWait: 'Please, wait',
                options: 'Options',
                selectDevice: 'Select Device',
                uploadMsg: 'Click here or drop a file to upload [Jpeg or Png image. 2MB max]',
            },
            notfoundPage: {
                notFound: 'Not Found',
                notFoundMsg: 'Requested resource could not be found. Apologies...',
            },
            components: {
                fileUpload: {
                    removeFile: 'Remove',
                    uploadMsg: 'Click here or drop a file to upload',
                    draggingMsg: 'Drop your file',
                    dragRejected: 'File not accepted',
                    invalidFile: '{{fileName}} is not a valid file.',
                },
            },
            pageMeta: {
                index: {
                    title: 'doDoubt Tools',
                    description: 'A collective list of publicly available tools prepared by doDoubt. QR code generator and phone skin builders are namely some of small widgets presented to the public. Technology solutions for everyone!',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, barcode, phone skin, phone frame, app store, google play, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-us/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                barcodes: {
                    title: 'doDoubt Tools | QR Tool',
                    description: 'You can develop your QR code on your own. Decorate your QR code with social links as well as your own brand image and url. Building a QR code was never that easy!',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, custom qr code, barcode, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-us/barcodes/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/barcodes/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/barcodes/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                phonePre: {
                    title: 'doDoubt Tools | Phone Skin',
                    description: 'Do you need phone-framed images for application store upload? You can develop your phone skin on your own. Add your phone images to desired phone frame. The widget allows you, exporting phone previews as a zip file.',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, phone skin, iphone, pixel, galaxy, phone frame',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-us/phonePreviews/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/phonePreviews/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/phonePreviews/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                notFound: {
                    title: 'doDoubt Tools | 404',
                    description: 'Resource not found. 404',
                    robots: 'noindex, nofollow',
                    googlebot: 'noindex, nofollow',
                    keywords: 'doDoubt',
                    alternate: [],
                },
            },
        },
    },
    'en-gb': {
        translation: {
            lang: 'en-gb',
            cookie: {
                consent: {
                    message: 'We use cookies to improve our services and to guarantee users the employment of its site features. By continuing to browse the site you\'re agreeing to our use of cookies.',
                    buttonTxt: 'Okay',
                },
            },
            header: {
                barcodes: 'QR Code',
                phoneSkin: 'Phone Skin',
                contact: 'Contact',
            },
            layout: {
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
                repo: 'Repository',
                fullAddress: 'Kuloglu M. Aga Hamami S. No:13/2 Beyoglu, Istanbul, Republic of TURKEY',
                menu: 'Menu',
            },
            barcodes: {
                sponsorMessage: 'QR project was sponsored by',
                bgColor: 'Background Color',
                foreColor: 'Foreground Color',
                textualData: 'Textual Data [URL]',
                imageWidth: 'Image Size [Height and Width px]',
                logoWidth: 'Logo Size [Height and Width px]',
                opacity: 'Logo Opacity [{{val}}]',
                logoType: 'Logo Type',
                uploadLogo: 'Upload Logo',
                qrShape: 'QR Shape',
                dot: 'Dot',
                square: 'Square',
                preview: 'Preview',
                exportJpg: 'Export JPG',
                exportPng: 'Export PNG',
                customLogo: 'Custom Logo',
                error: {
                    invalidImageHead: 'Invalid Image Size',
                    invalidImageMinMsg: 'Please enter a positive value for image size',
                    invalidImageMaxMsg: 'Image size cannot be larger than {{val}} px',
                    invalidLogoHead: 'Invalid Logo Size',
                    invalidLogoMinMsg: 'Please enter a positive value for logo size',
                    invalidLogoMaxMsg: 'Logo size cannot be larger than {{val}} px',
                },
                addBorder: 'Add Frame',
                wBorder: 'With Frame',
                woBorder: 'Without Frame',
                borderRad: 'Corner Radius [{{val}}]px',
                lineWidth: 'Line Width [{{val}}]px',
                borderCol: 'Frame Color',
            },
            indexPage: {
                desc: 'A collective list of publicly available tools prepared by doDoubt.',
                barcodeGen: 'QR Code Generator',
                phoneSkin: 'Phone Skins',
            },
            phonePrePage: {
                option: {
                    imacPro: 'iMac Pro',
                    iphonex: 'iPhone X',
                    iphone8: 'iPhone 8 [White]',
                    iphone8Gold: 'iPhone 8 [Gold]',
                    ipadpro: 'iPad Pro',
                    pixel: 'Pixel [White]',
                    pixelBlack: 'Pixel [Black]',
                    pixelBlue: 'Pixel [Blue]',
                    pixel2xl: 'Pixel 2 XL',
                    galaxys8: 'Galaxy S8 [Black]',
                    galaxys8Blue: 'Galaxy S8 [Blue]',
                    surfaceStudio: 'Surface Studio',
                    appleWatch: 'Apple Watch',
                },
                visual: 'Visual',
                uploadVisual: 'Upload Visual',
                preview: 'Preview',
                removePreview: 'Remove Preview',
                deviceScale: 'Device Scale',
                addPhoneView: 'Add Phone View',
                exportFilesJpeg: 'Export Files [jpeg]',
                exportFilesPng: 'Export Files [png]',
                scaleSmall: 'Small',
                scaleMedium: 'Medium',
                scaleLarge: 'Large',
                pleaseWait: 'Please, wait',
                options: 'Options',
                selectDevice: 'Select Device',
                uploadMsg: 'Click here or drop a file to upload [Jpeg or Png image. 2MB max]',
            },
            notfoundPage: {
                notFound: 'Not Found',
                notFoundMsg: 'Requested resource could not be found. Apologies...',
            },
            components: {
                fileUpload: {
                    removeFile: 'Remove',
                    uploadMsg: 'Click here or drop a file to upload',
                    draggingMsg: 'Drop your file',
                    dragRejected: 'File not accepted',
                    invalidFile: '{{fileName}} is not a valid file.',
                },
            },
            pageMeta: {
                index: {
                    title: 'doDoubt Tools',
                    description: 'A collective list of publicly available tools prepared by doDoubt. QR code generator and phone skin builders are namely some of small widgets presented to the public. Technology solutions for everyone!',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, barcode, phone skin, phone frame, app store, google play, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-gb/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                barcodes: {
                    title: 'doDoubt Tools | QR Tool',
                    description: 'You can develop your QR code on your own. Decorate your QR code with social links as well as your own brand image and url. Building a QR code was never that easy!',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, custom qr code, barcode, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-us/barcodes/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/barcodes/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/barcodes/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                phonePre: {
                    title: 'doDoubt Tools | Phone Skin',
                    description: 'Do you need phone-framed images for application store upload? You can develop your phone skin on your own. Add your phone images to desired phone frame. The widget allows you, exporting phone previews as a zip file.',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, phone skin, iphone, pixel, galaxy, phone frame',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/en-gb/phonePreviews/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/phonePreviews/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/phonePreviews/',
                            hreflang: 'tr-tr',
                        },
                    ],
                },
                notFound: {
                    title: 'doDoubt Tools | 404',
                    description: 'Resource not found. 404',
                    robots: 'noindex, nofollow',
                    googlebot: 'noindex, nofollow',
                    keywords: 'doDoubt',
                    alternate: [],
                },
            },
        },
    },
    'tr-tr': {
        translation: {
            lang: 'tr-tr',
            cookie: {
                consent: {
                    message: 'Hizmetlerimizi geliştirmek ve uygulamanın düzgün çalışması için çerezler kullanıyoruz. Uygulamayı kullanmaya devam ederek çerez kullanımını kabul etmiş oluyorsunuz.',
                    buttonTxt: 'Tamam',
                },
            },
            header: {
                barcodes: 'QR Kodu',
                phoneSkin: 'Telefon Kılıfı',
                contact: 'İletişim',
            },
            layout: {
                address: 'Adres',
                email: 'Eposta',
                phone: 'Telefon',
                repo: 'Depo',
                fullAddress: 'Kuloğlu M. Ağa Hamamı S. No:13/2 Beyoğlu, İstanbul, Türkiye',
                menu: 'Menü',
            },
            barcodes: {
                sponsorMessage: 'QR projesinin sponsoru',
                bgColor: 'Arka Renk',
                foreColor: 'Ön Renk',
                textualData: 'Metinsel Veri [URL]',
                imageWidth: 'Görsel Boyutu [Yükseklik ve Genişlik px]',
                logoWidth: 'Logo Boyutu [Yükseklik ve Genişlik px]',
                opacity: 'Logo Donukluk [{{val}}]',
                logoType: 'Logo Tipi',
                uploadLogo: 'Logo Yükleyin',
                qrShape: 'QR Şekli',
                dot: 'Nokta',
                square: 'Kare',
                preview: 'Önizle',
                exportJpg: 'JPG Oluştur',
                exportPng: 'PNG Oluştur',
                customLogo: 'Özel Logo',
                error: {
                    invalidImageHead: 'Geçersiz Görsel Boyutu',
                    invalidImageMinMsg: 'Lütfen görsel boyutuna pozitif değer girin',
                    invalidImageMaxMsg: 'Görsel boyutu {{val}} px\'den büyük olamaz',
                    invalidLogoHead: 'Geçersiz Logo Boyutu',
                    invalidLogoMinMsg: 'Lütfen logo boyutuna pozitif değer girin',
                    invalidLogoMaxMsg: 'Logo boyutu {{val}} px\'den büyük olamaz',
                },
                addBorder: 'Çerçeve Ekle',
                wBorder: 'Çerçeveli',
                woBorder: 'Çerçevesiz',
                lineWidth: 'Kenar Genişliği [{{val}}]px',
                borderRad: 'Köşelik Çapı [{{val}}]px',
                borderCol: 'Çerçeve Rengi',
            },
            indexPage: {
                desc: 'doDoubt tarafından hazırlanan ve haricen açık sunulan araçlar listesi',
                barcodeGen: 'QR Kod Oluşturucu',
                phoneSkin: 'Telefon Kılıfı',
            },
            phonePrePage: {
                option: {
                    imacPro: 'iMac Pro',
                    iphonex: 'iPhone X',
                    iphone8: 'iPhone 8 [Beyaz]',
                    iphone8Gold: 'iPhone 8 [Sarı]',
                    ipadpro: 'iPad Pro',
                    pixel: 'Pixel [Beyaz]',
                    pixelBlack: 'Pixel [Siyah]',
                    pixelBlue: 'Pixel [Mavi]',
                    pixel2xl: 'Pixel 2 XL',
                    galaxys8: 'Galaxy S8 [Siyah]',
                    galaxys8Blue: 'Galaxy S8 [Mavi]',
                    surfaceStudio: 'Surface Studio',
                    appleWatch: 'Apple Saat',
                },
                visual: 'Görsel',
                uploadVisual: 'Görsel Yükle',
                preview: 'Önizle',
                removePreview: 'Önizle Sil',
                deviceScale: 'Cihaz Ölçü',
                addPhoneView: 'Telefon Ekle',
                exportFilesJpeg: 'Dosyaları İndir [jpeg]',
                exportFilesPng: 'Dosyaları İndir [png]',
                scaleSmall: 'Küçük',
                scaleMedium: 'Orta',
                scaleLarge: 'Büyük',
                pleaseWait: 'Lütfen, bekleyin',
                options: 'Seçenekler',
                selectDevice: 'Cihaz Seçin',
                uploadMsg: 'Dosyayı sürükleyin veya tıklayarak dosyayı seçin [Jpeg veya Png görseli. 2MB en büyük]',
            },
            notfoundPage: {
                notFound: 'Bulunamadı',
                notFoundMsg: 'Talep edilen kaynak bulunamadı. Üzgünüz...',
            },
            components: {
                fileUpload: {
                    removeFile: 'Sil',
                    uploadMsg: 'Dosyayı sürükleyin veya tıklayarak dosyayı seçin',
                    draggingMsg: 'Dosyanızı bırakın',
                    dragRejected: 'Dosya kabul edilmedi',
                    invalidFile: '{{fileName}} geçerli bir dosya değil.',
                },
            },
            pageMeta: {
                index: {
                    title: 'doDoubt Tools',
                    description: 'doDoubt tarafından hazırlanan ve haricen açık sunulan araçlar. Herkes için teknoloji çözümleri!',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, barkod, code, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/',
                            hreflang: 'tr-tr',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/',
                            hreflang: 'en-us',
                        },
                    ],
                },
                barcodes: {
                    title: 'doDoubt Tools | QR Tool',
                    description: 'QR kodunuzu oluşturun. QR kodunuzu sosyal linkler veya kendi marka görselinizle ve dilediğiniz URL ile donatın. QR ',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, qr, barkod, gezin',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/barcodes/',
                            hreflang: 'tr-tr',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/barcodes/',
                            hreflang: 'en-gb',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/barcodes/',
                            hreflang: 'en-us',
                        },
                    ],
                },
                phonePre: {
                    title: 'doDoubt Tools | Telefon Kılıfı',
                    description: 'Uygulama mağazaları için telefon-çerçeveli görsellere ihtiyacınız var mı? Telefon kılıfınızı kendi kendinize oluşturabilirsiniz. Görselleri dilediğiniz telefon çerçevesine ekleyin. Araç telefon görsellerini sıkışıtılmış dosya olarak indirmenize izin vermektedir.',
                    robots: 'index, follow, archive',
                    googlebot: 'index, follow',
                    keywords: 'doDoubt, tools, telefon kılıfı, iphone, pixel, galaxy, phone frame',
                    alternate: [
                        {
                            link: 'https://tools.appdoubt.com/tr-tr/phonePreviews/',
                            hreflang: 'tr-tr',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-us/phonePreviews/',
                            hreflang: 'en-us',
                        },
                        {
                            link: 'https://tools.appdoubt.com/en-gb/phonePreviews/',
                            hreflang: 'en-gb',
                        },
                    ],
                },
                notFound: {
                    title: 'doDoubt Tools | 404',
                    description: 'Aranan kaynak bulunamadı. 404',
                    robots: 'noindex, nofollow',
                    googlebot: 'noindex, nofollow',
                    keywords: 'doDoubt',
                    alternate: [],
                },
            },
        },
    },
};

export default trans;
